import { Divider, Flex, Typography } from "antd";
import { FatButton } from "components/FatButton/FatButton/";
import { EXPERIENCE_OBJECTIVES } from "data/tones/";
import { useTranslate } from "#src/hooks";
import { useEffect, useRef } from "react";
import { MediaProjectStoryboards } from "../../types";

export const ObjectivesSelect = ({
  selectedObjectives,
  storyboardSettings,
  setUserSelectedObjectives,
}: {
  selectedObjectives: string[];
  storyboardSettings?: MediaProjectStoryboards;
  setUserSelectedObjectives: React.Dispatch<
    React.SetStateAction<string[] | null>
  >;
}) => {
  const t = useTranslate();
  const filteredTones = Object.keys(EXPERIENCE_OBJECTIVES);

  // Keep a ref of storyboard objectives for use in callbacks without causing re-memoization
  const storyboardObjectivesRef = useRef(storyboardSettings?.objectives);
  useEffect(() => {
    storyboardObjectivesRef.current = storyboardSettings?.objectives;
  }, [storyboardSettings?.objectives]);

  const handleSelectTone = (tone: string) => {
    setUserSelectedObjectives((prev) => {
      const currentObjectives = prev ?? storyboardObjectivesRef.current ?? [];
      if (currentObjectives.includes(tone)) {
        return currentObjectives.filter(
          (selectedTone) => selectedTone !== tone
        );
      } else {
        return [...currentObjectives, tone];
      }
    });
  };

  return (
    <Flex vertical gap={10} align="center" justify="center">
      <Typography.Title
        level={4}
        style={{ fontWeight: 400, margin: 0, textAlign: "center" }}
      >
        {t("projects.components.ProjectCreateWizard.selectObjective")}
      </Typography.Title>
      <Typography.Text type="secondary" style={{ textAlign: "center" }}>
        {t("projects.components.ProjectCreateWizard.thisHelps")}
      </Typography.Text>
      <Flex wrap justify="center">
        {filteredTones.map((tone) => {
          const Icon = EXPERIENCE_OBJECTIVES[tone]?.icon;
          const toneTranslationData = t(
            `src.data.experienceObjectives.${tone}`,
            {
              returnObjects: true,
              defaultValue: {},
            }
          ) as unknown as {
            name: string;
            description: string;
            characteristics: string[];
          };
          return (
            <Flex key={tone}>
              <Flex
                style={{
                  margin: 10,
                }}
                align="center"
                justify="center"
              >
                <FatButton
                  title={toneTranslationData.name}
                  content={
                    <Flex vertical gap={10} style={{ marginTop: 10 }}>
                      <span style={{ fontWeight: 500 }}>
                        {toneTranslationData.description}
                      </span>
                      {toneTranslationData.characteristics.join(" • ")}
                    </Flex>
                  }
                  icon={Icon ? <Icon size={28} weight="duotone" /> : null}
                  onClick={() => handleSelectTone(tone)}
                  type={
                    selectedObjectives.includes(tone) ? "primary" : "default"
                  }
                  checked={selectedObjectives.includes(tone)}
                  style={{ height: 250, width: 210 }}
                  size="small"
                  contentFontWeight={300}
                />
              </Flex>
            </Flex>
          );
        })}
      </Flex>
      <Divider style={{ margin: 0 }}>
        <Typography.Text type="secondary">{t("or")}</Typography.Text>
      </Divider>
    </Flex>
  );
};
